<div style="padding:3rem; height:100vh" [style.background-color]="color">
  <zxing-scanner (scanComplete)="scan($event)"></zxing-scanner>
  {{ value }}
</div>
